<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import {login_site} from "@/api/api.js"
  export default {
    data(){
      return{
        site:{},
        keepName:['Vote','Rank'],
        isWeixin:sessionStorage.isWeixin
      }
    },
    watch: {
      $route(to, from) {
        JSON.parse(sessionStorage.getItem('info'))?document.title = JSON.parse(sessionStorage.getItem('info')).title:null
      },
    },
    async created(){
      try {
        let result =await login_site()
        sessionStorage.setItem('site',JSON.stringify(result.data.data))
        this.site=result.data.data
        document.querySelector('link[rel="icon"]').href=this.site.sysico
        document.title=JSON.parse(sessionStorage.getItem('info')).title
      } catch (error) {
      }

    }
  }
</script>

<style lang="less" scoped>
#app{
  box-sizing: border-box;
  width: 100%;
  // margin-bottom: env(safe-area-inset-bottom);
  // overflow: auto; 千万不要加
}

</style>